// extracted by mini-css-extract-plugin
module.exports = {"productionRateTable":"productionRateTable_productionRateTable__2a0u9"};